import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNotify } from '@/components/snackbar';
import { resendEventHistory } from '@/services/apps';
import { getWebhookResendErrorMessage, mapWebhookExecutionDetail } from '@/utils/webhooks';

// As listas de atividade e os logs de cada webhook leem a mesma view de histórico no backend, e o
// mapWebhookActivity guarda o item cru em `raw`: o detalhe sai dele sem outra requisição.
export default function useWebhookExecutionDetails() {
  const queryClient = useQueryClient();
  const notify = useNotify();
  const [execution, setExecution] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  const { mutate: resendExecution, isLoading: isResending } = useMutation({
    mutationFn: (eventHistoryId) => resendEventHistory({ eventHistoryId }),
    onSuccess: () => {
      notify.success('Evento reenviado com sucesso!');
      // As atividades ficam 5 minutos em cache e não recarregam ao montar: sem invalidar, a
      // tentativa nova só apareceria depois disso.
      queryClient.invalidateQueries({ queryKey: ['webhook-activities'] });
      queryClient.invalidateQueries({ queryKey: ['webhook-status-metrics'] });
      queryClient.invalidateQueries({ queryKey: ['webhook-log-history'] });
    },
    onError: (error) => {
      notify.error(getWebhookResendErrorMessage(error));
    },
  });

  const openDetails = (activity) => {
    const raw = activity?.raw || {};

    setExecution(mapWebhookExecutionDetail(raw, raw.app));
    setIsOpen(true);
  };

  // A execução continua guardada para a modal não esvaziar durante a animação de saída.
  const closeDetails = () => {
    setIsOpen(false);
  };

  const resend = () => {
    if (!execution?.id) {
      notify.warning('Não foi possível identificar o evento para reenvio.');
      return;
    }

    resendExecution(execution.id);
  };

  return { execution, isOpen, isResending, openDetails, closeDetails, resend };
}
